import { useTranslation } from 'react-i18next';

// Components
import TableRow from '../TableRowShoppingCart';

// Styles
import styles from './index.module.sass';
import Skeleton from '@mui/material/Skeleton';

type Props = {
  order: Object,
  getOrder: Function,
  device: Object,
};

export default function OrderTable({ order = {}, getOrder, device, loading }: Props): React$Node {
  const { t } = useTranslation('order');
  const tableTitles = t('tableTitles', { returnObjects: true });

  const orderDetail = order?.detallePedido || [];

  const screenSize = device?.screenSize || 'desktop';

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.header}>
        <div className={`${styles.column} ${styles.product}`}>{tableTitles[0]}</div>
        <div className={`${styles.column} ${styles.actions}`}>{tableTitles[6]}</div>
        <div className={`${styles.column}`}>{tableTitles[1]}</div>
        <div className={`${styles.column}`}>{tableTitles[3]}</div>
        <div className={`${styles.column}`}>{tableTitles[4]}</div>
        <div className={`${styles.column}`}>{tableTitles[5]}</div>
      </div>
      <div className={styles.tableData}>
        {(loading && (
          <div>
            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />

            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />

            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />
          </div>
        )) ||
          orderDetail.map((val, key) => {
            return <TableRow node={val} key={key} getOrder={getOrder} device={device} t={t} />;
          })}
      </div>
    </div>
  );
}
